<template>
  <v-container fluid class="px-0 py-0">
    <v-main>
      <transition name="dropdownnav">
        <navigation v-if="animationDelay > 0.2"/>
      </transition>

      <section :id="pageName" class="page">
        <slot></slot>
      </section>

      <contact-highlight />
    </v-main>
  </v-container>
</template>

<script>

export default {
  name: 'Page',

  props: {
    pageName: String
  },

  data: () => ({

  }),

  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style scoped>
.page {
  width: 100vw;
  min-height: 100vh;
  height: auto;
  background-color: #fff;
}
</style>
